<nz-layout>
  <nz-sider
    nzCollapsible
    [(nzCollapsed)]="isCollapsed"
    [nzTrigger]="null"
    [nzWidth]="280"
    [nzCollapsedWidth]="64">
    <div class="logo">
      <i nz-icon nzType="shopping" nzTheme="outline"></i>
      <span *ngIf="!isCollapsed">门店管理系统</span>
    </div>
    <div class="menu">
      <ul nz-menu nzTheme="dark" nzMode="inline">
        <li nz-submenu nzIcon="setting" nzTitle="基本信息">
          <ul>
            <li nz-menu-item routerLink="/home/shopsale.management/shopManagement" [nzMatchRouter]="true">
              <i nz-icon nzType="shop" nzTheme="outline"></i>
              <span>店铺管理</span>
            </li>
            <li nz-menu-item routerLink="/home/shopsale.management/shopgrantManagement" [nzMatchRouter]="true">
              <i nz-icon nzType="key" nzTheme="outline"></i>
              <span>店铺授权</span>
            </li>
            <li nz-menu-item routerLink="/home/shopsale.management/releaseManagement" [nzMatchRouter]="true">
              <i nz-icon nzType="upload" nzTheme="outline"></i>
              <span>商品管理</span>
            </li>
            <li nz-menu-item routerLink="/home/shopsale.management/giftManagement" [nzMatchRouter]="true">
              <i nz-icon nzType="gift" nzTheme="outline"></i>
              <span>礼品管理</span>
            </li>
          </ul>
        </li>
        <li nz-submenu nzIcon="mobile" nzTitle="收银管理">
          <ul>
            <li nz-menu-item routerLink="/home/shopsale.management/categoryManagement" [nzMatchRouter]="true">
              <i nz-icon nzType="appstore" nzTheme="outline"></i>
              <span>品类管理</span>
            </li>
            <li nz-menu-item routerLink="/home/shopsale.management/shopsaleRecommendation" [nzMatchRouter]="true">
              <i nz-icon nzType="appstore" nzTheme="outline"></i>
              <span>商品橱窗</span>
            </li>
            <li nz-menu-item routerLink="/home/shopsale.management/soldOutSkuManagement" [nzMatchRouter]="true">
              <i nz-icon nzType="stop" nzTheme="outline"></i>
              <span>售罄商品</span>
            </li>
          </ul>
        </li>

        <li nz-submenu nzIcon="shopping-cart" nzTitle="订单管理">
          <ul>
            <li nz-menu-item routerLink="/home/shopsale.management/orderManagement" [nzMatchRouter]="true">
              <i nz-icon nzType="shopping" nzTheme="outline"></i>
              <span>订单管理</span>
            </li>
            <li nz-menu-item routerLink="/home/shopsale.management/acceptManagement" [nzMatchRouter]="true">
              <i nz-icon nzType="check-circle" nzTheme="outline"></i>
              <span>接单配送</span>
            </li>
            <li nz-menu-item routerLink="/home/shopsale.management/shipmentManagement" [nzMatchRouter]="true">
              <i nz-icon nzType="check-circle" nzTheme="outline"></i>
              <span>接单发货</span>
            </li>
            <li nz-menu-item routerLink="/home/shopsale.management/returnGoodsManagement" [nzMatchRouter]="true">
              <i nz-icon nzType="rollback" nzTheme="outline"></i>
              <span>退货管理</span>
            </li>
            <li nz-menu-item routerLink="/home/shopsale.management/returnMoneyManagement" [nzMatchRouter]="true">
              <i nz-icon nzType="dollar" nzTheme="outline"></i>
              <span>退款管理</span>
            </li>
            <li nz-menu-item routerLink="/home/shopsale.management/afterServiceManagement" [nzMatchRouter]="true">
              <i nz-icon nzType="customer-service" nzTheme="outline"></i>
              <span>售后管理</span>
            </li>
          </ul>
        </li>

        <li nz-submenu nzIcon="gift" nzTitle="促销&裂变">
          <ul>
            <li nz-menu-item routerLink="/home/shopsale.management/releasepriceManagement" [nzMatchRouter]="true">
              <i nz-icon nzType="percentage" nzTheme="outline"></i>
              <span>促销活动价格</span>
            </li>
            <li nz-menu-item routerLink="/home/shopsale.management/releaseIntegrateManagement" [nzMatchRouter]="true">
              <i nz-icon nzType="trophy" nzTheme="outline"></i>
              <span>商品积分管理</span>
            </li>
            <li nz-menu-item routerLink="/home/shopsale.management/integrateMoneyManagement" [nzMatchRouter]="true">
              <i nz-icon nzType="wallet" nzTheme="outline"></i>
              <span>消费积分抵现</span>
            </li>
            <li nz-menu-item routerLink="/home/shopsale.management/bindGiftManagement" [nzMatchRouter]="true">
              <i nz-icon nzType="gift" nzTheme="outline"></i>
              <span>捆绑礼品促销</span>
            </li>
          </ul>
        </li>

        <li nz-submenu nzIcon="crown" nzTitle="权益管理">
          <ul>
            <li nz-menu-item routerLink="/home/shopsale.management/memberEquity/equity.gift.mgr" [nzMatchRouter]="true">
              <i nz-icon nzType="gift" nzTheme="outline"></i>
              <span>礼品管理</span>
            </li>
            <li nz-menu-item routerLink="/home/shopsale.management/memberEquity/equity.mgr" [nzMatchRouter]="true">
              <i nz-icon nzType="crown" nzTheme="outline"></i>
              <span>普通权益</span>
            </li>
            <li nz-menu-item routerLink="/home/shopsale.management/memberEquity/gift.equity" [nzMatchRouter]="true">
              <i nz-icon nzType="gift" nzTheme="outline"></i>
              <span>礼品权益</span>
            </li>
            <li nz-menu-item routerLink="/home/shopsale.management/memberEquity/cashback.equity" [nzMatchRouter]="true">
              <i nz-icon nzType="dollar" nzTheme="outline"></i>
              <span>返现权益</span>
            </li>
            <li nz-menu-item routerLink="/home/shopsale.management/memberEquity/release.equity.equity" [nzMatchRouter]="true">
              <i nz-icon nzType="shopping" nzTheme="outline"></i>
              <span>预购权益</span>
            </li>
            <li nz-menu-item routerLink="/home/shopsale.management/memberEquity/wy.equity" [nzMatchRouter]="true">
              <i nz-icon nzType="home" nzTheme="outline"></i>
              <span>物业费权益</span>
            </li>
            <li nz-menu-item routerLink="/home/shopsale.management/memberEquity/parking.equity" [nzMatchRouter]="true">
              <i nz-icon nzType="car" nzTheme="outline"></i>
              <span>停车费权益</span>
            </li>
            <li nz-menu-item routerLink="/home/shopsale.management/memberEquity/electricity.equity" [nzMatchRouter]="true">
              <i nz-icon nzType="thunderbolt" nzTheme="outline"></i>
              <span>电费权益</span>
            </li>
            <li nz-menu-item routerLink="/home/shopsale.management/memberEquity/water.equity" [nzMatchRouter]="true">
              <i nz-icon nzType="droplet" nzTheme="outline"></i>
              <span>水费权益</span>
            </li>
            <li nz-menu-item routerLink="/home/shopsale.management/memberEquity/gas.equity" [nzMatchRouter]="true">
              <i nz-icon nzType="fire" nzTheme="outline"></i>
              <span>燃气权益</span>
            </li>
            <li nz-menu-item routerLink="/home/shopsale.management/memberEquity/partner.equity" [nzMatchRouter]="true">
              <i nz-icon nzType="solution" nzTheme="outline"></i>
              <span>方案权益</span>
            </li>
            <li nz-menu-item routerLink="/home/shopsale.management/memberEquity/equity.release" [nzMatchRouter]="true">
              <i nz-icon nzType="upload" nzTheme="outline"></i>
              <span>权益上架</span>
            </li>
            <li nz-menu-item routerLink="/home/shopsale.management/memberEquity/equity.recommendation" [nzMatchRouter]="true">
              <i nz-icon nzType="like" nzTheme="outline"></i>
              <span>权益推广</span>
            </li>
            <li nz-menu-item routerLink="/home/shopsale.management/memberEquity/equity.sale.order" [nzMatchRouter]="true">
              <i nz-icon nzType="shopping-cart" nzTheme="outline"></i>
              <span>权益销售</span>
            </li>
          </ul>
        </li>
        <li nz-menu-item routerLink="/home/shopsale.management/userShopsaleManagement" [nzMatchRouter]="true">
          <i nz-icon nzType="user" nzTheme="outline"></i>
          <span>收银员管理</span>
        </li>
        <li nz-menu-item routerLink="/home/shopsale.management/userShopManagerManagement" [nzMatchRouter]="true">
          <i nz-icon nzType="user" nzTheme="outline"></i>
          <span>门店管理员</span>
        </li>
        <li nz-submenu nzIcon="team" nzTitle="会员管理">
          <ul>
            <li nz-menu-item routerLink="/home/shopsale.management/memberManagement/member.mgr" [nzMatchRouter]="true">
              <i nz-icon nzType="user" nzTheme="outline"></i>
              <span>会员管理</span>
            </li>
            <li nz-menu-item routerLink="/home/shopsale.management/memberManagement/member.equity" [nzMatchRouter]="true">
              <i nz-icon nzType="crown" nzTheme="outline"></i>
              <span>会员权益</span>
            </li>
            <li nz-menu-item routerLink="/home/shopsale.management/memberManagement/member.balance" [nzMatchRouter]="true">
              <i nz-icon nzType="plus-circle" nzTheme="outline"></i>
              <span>余额入账</span>
            </li>
            <li nz-menu-item routerLink="/home/shopsale.management/memberManagement/balance.out" [nzMatchRouter]="true">
              <i nz-icon nzType="minus-circle" nzTheme="outline"></i>
              <span>余额核销</span>
            </li>
          </ul>
        </li>

        <li nz-submenu nzIcon="ticket" nzTitle="卡卷管理">
          <ul>
            <li nz-menu-item routerLink="/home/shopsale.management/rollManagement/coupon.mgr" [nzMatchRouter]="true">
              <i nz-icon nzType="ticket" nzTheme="outline"></i>
              <span>优惠卷管理</span>
            </li>
            <li nz-menu-item routerLink="/home/shopsale.management/rollManagement/coupontheme.mgr" [nzMatchRouter]="true">
              <i nz-icon nzType="skin" nzTheme="outline"></i>
              <span>优惠卷主题</span>
            </li>
            <li nz-menu-item routerLink="/home/shopsale.management/rollManagement/coupon.gift.mgr" [nzMatchRouter]="true">
              <i nz-icon nzType="gift" nzTheme="outline"></i>
              <span>赠品卷礼品</span>
            </li>
            <li nz-menu-item routerLink="/home/shopsale.management/rollManagement/coupon.gift.binding" [nzMatchRouter]="true">
              <i nz-icon nzType="link" nzTheme="outline"></i>
              <span>礼品关联卷</span>
            </li>
            <li nz-menu-item routerLink="/home/shopsale.management/rollManagement/release.sku.coupon.binding" [nzMatchRouter]="true">
              <i nz-icon nzType="paper-clip" nzTheme="outline"></i>
              <span>优惠卷绑定</span>
            </li>
            <li nz-menu-item routerLink="/home/shopsale.management/rollManagement/voucher.mgr" [nzMatchRouter]="true">
              <i nz-icon nzType="credit-card" nzTheme="outline"></i>
              <span>代金券管理</span>
            </li>
            <li nz-menu-item routerLink="/home/shopsale.management/rollManagement/release.sku.voucher.binding" [nzMatchRouter]="true">
              <i nz-icon nzType="paper-clip" nzTheme="outline"></i>
              <span>代金券绑定</span>
            </li>
          </ul>
        </li>

        <li nz-submenu nzIcon="trophy" nzTitle="抽奖管理">
          <ul>
            <li nz-menu-item routerLink="/home/shopsale.management/prizeManagement/prize.mgr" [nzMatchRouter]="true">
              <i nz-icon nzType="trophy" nzTheme="outline"></i>
              <span>奖品信息</span>
            </li>
            <li nz-menu-item routerLink="/home/shopsale.management/prizeManagement/prize.lottery" [nzMatchRouter]="true">
              <i nz-icon nzType="gift" nzTheme="outline"></i>
              <span>抽奖信息</span>
            </li>
            <li nz-menu-item routerLink="/home/shopsale.management/prizeManagement/lottery.instance" [nzMatchRouter]="true">
              <i nz-icon nzType="rocket" nzTheme="outline"></i>
              <span>抽奖活动</span>
            </li>
          </ul>
        </li>

        <li nz-submenu nzIcon="transaction" nzTitle="兑付管理">
          <ul>
            <li nz-menu-item routerLink="/home/shopsale.management/cashManagement/gift.cash" [nzMatchRouter]="true">
              <i nz-icon nzType="gift" nzTheme="outline"></i>
              <span>礼品兑付</span>
            </li>
            <li nz-menu-item routerLink="/home/shopsale.management/cashManagement/cashback.cash" [nzMatchRouter]="true">
              <i nz-icon nzType="dollar" nzTheme="outline"></i>
              <span>返利兑付</span>
            </li>
            <li nz-menu-item routerLink="/home/shopsale.management/cashManagement/release.cash" [nzMatchRouter]="true">
              <i nz-icon nzType="shopping" nzTheme="outline"></i>
              <span>预购兑付</span>
            </li>
            <li nz-menu-item routerLink="/home/shopsale.management/cashManagement/electricity.cash" [nzMatchRouter]="true">
              <i nz-icon nzType="thunderbolt" nzTheme="outline"></i>
              <span>电费兑付</span>
            </li>
            <li nz-menu-item routerLink="/home/shopsale.management/cashManagement/water.cash" [nzMatchRouter]="true">
              <i nz-icon nzType="droplet" nzTheme="outline"></i>
              <span>水费兑付</span>
            </li>
            <li nz-menu-item routerLink="/home/shopsale.management/cashManagement/wy.cash" [nzMatchRouter]="true">
              <i nz-icon nzType="home" nzTheme="outline"></i>
              <span>物业费兑付</span>
            </li>
            <li nz-menu-item routerLink="/home/shopsale.management/cashManagement/parking.cash" [nzMatchRouter]="true">
              <i nz-icon nzType="car" nzTheme="outline"></i>
              <span>停车费兑付</span>
            </li>
            <li nz-menu-item routerLink="/home/shopsale.management/cashManagement/gas.cash" [nzMatchRouter]="true">
              <i nz-icon nzType="fire" nzTheme="outline"></i>
              <span>燃气费兑付</span>
            </li>
            <li nz-menu-item routerLink="/home/shopsale.management/cashManagement/partner.cash" [nzMatchRouter]="true">
              <i nz-icon nzType="solution" nzTheme="outline"></i>
              <span>方案兑付</span>
            </li>
            <li nz-menu-item routerLink="/home/shopsale.management/cashManagement/freeShipping.cash" [nzMatchRouter]="true">
              <i nz-icon nzType="gift" nzTheme="outline"></i>
              <span>今日免单兑付</span>
            </li>
          </ul>
        </li>
        <li nz-submenu nzIcon="transaction" nzTitle="调度任务">
          <ul nz-menu nzTheme="dark" nzMode="inline">
            <li nz-menu-item routerLink="/home/shopsale.management/shedulingManagement" [nzMatchRouter]="true">
              <i nz-icon nzType="shop" nzTheme="outline"></i>
              <span>调度管理器</span>
            </li>
            <li nz-menu-item routerLink="/home/shopsale.management/jobManagement" [nzMatchRouter]="true">
              <i nz-icon nzType="shop" nzTheme="outline"></i>
              <span>调度管任务</span>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </nz-sider>
  <nz-layout>
    <nz-header>
      <div class="header-content">
        <div class="header-left">
          <span class="back-btn" nz-icon nzType="arrow-left" nzTheme="outline" (click)="goBackToSystemSelection()"></span>
          <span class="back-text" (click)="goBackToSystemSelection()">返回系统选择</span>
          <span class="trigger" nz-icon
                [nzType]="isCollapsed ? 'menu-unfold' : 'menu-fold'"
                (click)="isCollapsed = !isCollapsed"></span>
        </div>
        <div class="select-shop">
          <shop-system-info></shop-system-info>
        </div>
        <div class="header-right">
          <i nz-icon nzType="user" nzTheme="outline"></i>
          <span>管理员</span>
        </div>
      </div>
    </nz-header>
    <nz-content>
      <nz-breadcrumb [nzAutoGenerate]="true" [nzRouteLabel]="'title'"></nz-breadcrumb>
      <div class="inner-content">
        <router-outlet/>
      </div>
    </nz-content>
    <nz-footer>
      <span>商城管理系统 ©2024 - Powered by Angular & Ant Design</span>
    </nz-footer>
  </nz-layout>
</nz-layout>
